import FieldConfig from "../../../proto/field-config"
import FieldColor from "../../../generic/color/color"
import FieldProjectColor_Editable from "./render/editable"
import FieldProto_TableCell from "../../../proto/render/table/table-cell"
import ItemModelV2 from "../../../../model2/item2/item-model"
import TasksViewManager from "../../../../gd-modules/tasks-view/core/manager"
import FieldProto_updateView from "../../../proto/render/table/function/update-view"


export default class FieldProjectColor extends FieldColor {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Project Color";
        this.label      = "Project Color"

        this.clearButton                    = false

        // this.renderComponents.tableCell = FieldProjectTotalOpenAll_TableCell

        this.renderComponents.editable      = FieldProjectColor_Editable // tut ochen' drugoi render eslio chto...
        this.renderComponents.tableCell      = FieldProto_TableCell // tut ochen' drugoi render eslio chto...


        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    tableCellOnValueChange = (item: ItemModelV2, value:any, manager:TasksViewManager) => {


        item.project.color = value
        item.project.save()

        item.updateLastUpdateTime() // otherwise it wont re-render

        // need it becuase of workday duration depends on Assignee
        FieldProto_updateView(manager as TasksViewManager, this)

    }

}